import { useState, useEffect, useRef, useMemo } from "react";
import {
  IndexComponentFeatureSection,
  IndexComponentHeaderBottomHeroContainer,
  IndexComponentHeaderBottomImageContainer,
  IndexComponentHeaderHeroDecriptionTextWrapper,
  IndexComponentHeaderHeroDiv,
  IndexComponentHeaderHeroHeaderTextWrapper,
  IndexComponentMainDiv,
  IndexComponentTrustedSection,
} from "../../styles/indexcomponentsstyles/indexcomponentstyles";
import HeaderComponent from "../reusable/header/header";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
import { ReactComponent as OpenAiIcon } from "./assets/openai-brands-solid-full.svg";
import { ReactComponent as DropDownIcon } from "./assets/angle-down-solid-full.svg";
import { ReactComponent as BrainIcon } from "./assets/brain-solid-full.svg";
import GptLogo from "../integrationcomponents/assets/gpt.jpg";
import ClaudeLogo from "../integrationcomponents/assets/claude.jpg";
import GeminiLogo from "../integrationcomponents/assets/gemini.png";
import MetaLogo from "../integrationcomponents/assets/meta.png";
import DeepSeekLogo from "../integrationcomponents/assets/deepseek.jpg";
import MistralLogo from "../integrationcomponents/assets/mistral.jpg";
import GrokLogo from "../integrationcomponents/assets/grok.jpg";
import SonarLogo from "../integrationcomponents/assets/sonar.jpg";
import IndexDashbordImageComponent from "./indexherodashboardcomponent";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import IndexModelComponent from "./indexmodelcomponents";
import IndexChatComponent from "./indexchatcomponent";
import IndexActionComponent from "./indexactioncomponent";
import IndexPrComponent from "./indexprcomponent";
import IndexDemoComponent from "./indexdemosectioncomponent";
import IndexFeaturesComponent from "./indexfeaturescomponent";
import IndexIntegrationComponent from "./indexintegrationcomponent";
import IndexReviewsComponent from "./indexsreviewscomponent";
import IndexCtaComponent from "./indexctacomponent";
import IndexFaqComponent from "./indexfaqcomponent";
import Footer from "../reusable/footer/footer";
import Bg_icon from "./assets/Hero.png"
import { openVsCodeExtension } from "../../utils/vscodeLauncher";
const IndexComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const heroTextRef = useRef<HTMLDivElement>(null);
  const [headerSentence] = useState<string>(
    "Unlock Every AI Provider in Your  Editor",
  );
  const headerWords = headerSentence.trim().split(" ");

  const [descriptionSentence] = useState<string>(
    "All your favorite AI providers, unified inside your Editor. Enjoy seamless workflows without leaving your editor. ",
  );
  const decriptionWords = descriptionSentence.trim().split(" ");

  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const typingSpeed = 150;
  const deletingSpeed = 50;
  const pauseTime = 2000;
  const words = useMemo(() => [
    "Start a Chat...",
    "Launch a workflow...",
    "Analyze Data structure...",
  ], [])

  useEffect(() => {
    const i = loopNum % words.length;
    const fullText = words[i];

    const handleType = () => {
      setText((current) => {
        if (isDeleting) {
          return fullText.substring(0, current.length - 1);
        } else {
          return fullText.substring(0, current.length + 1);
        }
      });
    };

    let timer: ReturnType<typeof setTimeout>;

    if (isDeleting) {
      if (text === "") {
        setIsDeleting(false);
        setLoopNum((prev) => prev + 1);
        timer = setTimeout(handleType, 500);
      } else {
        timer = setTimeout(handleType, deletingSpeed);
      }
    } else {
      if (text === fullText) {
        timer = setTimeout(() => setIsDeleting(true), pauseTime);
      } else {
        timer = setTimeout(handleType, typingSpeed);
      }
    }

    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, words]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (heroTextRef.current) {
      observer.observe(heroTextRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <IndexComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>

      <IndexComponentHeaderHeroDiv>
        <div className=" gradient-container">
        <img src={Bg_icon} alt="" style={{width:"100%",objectFit:"fill"}} ></img>
        </div>


        <div className="index-header-hero-video-holder">
          <div>
            <video
             
              loop
              muted
            ></video>
          </div>
        </div>
        <div className="index-header-hero-content-holder">
          <section className="index-header-hero-section-top">
            <div className="section-text">
              <div className="section-title-block">
                <HeaderSpan text="Your Universal AI Editor" />

                <IndexComponentHeaderHeroHeaderTextWrapper
                  ref={heroTextRef}
                  className={isVisible ? "is-visible" : ""}
                >
                  { }
                  <h1>
                    {headerWords.map((item, index) => (
                      <span
                        key={"block-header-text-wrapper-" + index}
                        className="text-exit-wrapper"
                        style={{ animationDelay: "10s" }}
                      >
                        <span
                          style={{
                            animationDelay: `calc(${index}*0.05s)`,
                          }}
                          className="block-header-h1-text-span reveal-text-span"
                        >
                          {item}
                        </span>
                        &nbsp;
                      </span>
                    ))}
                  </h1>
                </IndexComponentHeaderHeroHeaderTextWrapper>
              </div>
              <div className="section-description-block">
                <IndexComponentHeaderHeroDecriptionTextWrapper
                  className={isVisible ? "is-visible" : ""}
                >
                  <p>
                    {decriptionWords.map((item, index) => (
                      <span
                        key={"block-header-text-wrapper-" + index}
                        className="text-exit-wrapper"
                        style={{ animationDelay: "10s" }}
                      >
                        <span
                          style={{
                            animationDelay: `calc(${index}*0.05s)`,
                          }}
                          className="block-header-h1-text-span reveal-text-span"
                        >
                          {item}&nbsp;
                        </span>
                      </span>
                    ))}
                  </p>
                </IndexComponentHeaderHeroDecriptionTextWrapper>
              </div>
            </div>
            <div className="block-cta-holder">
              <div className="block-cta-button-holder">
                <div className="index-button-holder">
                  <ButtonComponent title="Get started - free" onclick={openVsCodeExtension} />
                </div>
                <div className="index-button-holder">
                  <ButtonComponentVariant title="View Pricing " link="/pricing" />
                </div>
              </div>
            </div>
          </section>
          <section className="index-header-hero-section-bottom">
            <IndexComponentHeaderBottomHeroContainer>
              <div className="chat-modal-container">
                <div>
                  <div className="chat-modal-content-holder">
                    <div className="background-fill" />
                    <div className="chat-modal-content">
                      <div className="chat-modal-content-section">
                        <div>
                          <div className="chat-modal-model-selector">
                            <div className="icon-container">
                              <div>
                                <OpenAiIcon className="openai" />
                              </div>
                            </div>
                            <div className="model-text-wrapper">
                              <p>GPT 5.5</p>
                            </div>
                            <div className="icon-container">
                              <div>
                                <DropDownIcon className="small" />{" "}
                              </div>
                            </div>
                          </div>
                          
                          <div className="chat-modal-selector">
                            <div className="icon-container">
                              <div>
                                <BrainIcon className="small" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="chat-modal-content-section">
                        <span className="chat-modal-input-text">
                          <span className="typing-span">{text}</span>
                          <span className="blinking-cursor">|</span>
                        </span>
                      </div>
                      <div className="chat-modal-content-section">
                        <div className="chat-modal-action-holder">
                          <div className="chat-modal-action-container">
                            <div className=" chat-modal-selector chat-modal-selector-large-padding">
                              <div className="text-wrapper">
                                <p>Chat</p>
                              </div>
                            </div>
                            <div className=" chat-modal-selector chat-modal-selector-large-padding">
                              <div className="text-wrapper">
                                <p>Launch workflow</p>
                              </div>
                            </div>{" "}
                            <div className=" chat-modal-selector chat-modal-selector-large-padding">
                              <div className="text-wrapper">
                                <p>Data Analysis</p>
                              </div>
                            </div>
                          </div>
                          <div>
                            <ButtonComponent
                              title="send"
                              icon={
                                <OpenAiIcon
                                  style={{ width: "20px", height: "20px" }}
                                ></OpenAiIcon>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </IndexComponentHeaderBottomHeroContainer>
            <IndexComponentHeaderBottomImageContainer>
              <div>
                <div className="dashboard-image-container">
                  <div className="image-container">
                    <IndexDashbordImageComponent />
                  </div>
                </div>
              </div>
            </IndexComponentHeaderBottomImageContainer>
          </section>
        </div>
      </IndexComponentHeaderHeroDiv>

      <IndexComponentTrustedSection>
        <div>
          <section className="trusted-section-container">
            <div className="trusted-section-holder">
              <div>
                <div className="trusted-section-text">
                  <p>Trusted by 10,000+ users worldwide</p>
                </div>
              </div>

              <div className="trusted-section-marque-container">
                <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-right" />
                <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-left" />

                <div className="trusted-section-marque-scroll-holder">
                  <section>
                    <ul className="trusted-section-marque-scroll-list">
                      {Companys.map((item, index) => (
                        <li
                          key={index + "marquee items"}
                          className="trusted-section-marque-scroll-list-item"
                        >
                          <div>
                            <div>
                              <img
                                src={item.logo}
                                alt={item.name}
                                className="trusted-section-marque-scroll-list-item-icon"
                              />
                            </div>
                          </div>
                          <div className="trusted-section-marque-scroll-list-item-text">
                            <div>
                              <p>{item.name} </p>
                            </div>
                          </div>
                        </li>
                      ))}
                      {Companys.map((item, index) => (
                        <li
                          key={index + "marquee items"}
                          className="trusted-section-marque-scroll-list-item"
                        >
                          <div>
                            <div>
                              <img
                                src={item.logo}
                                alt={item.name}
                                className="trusted-section-marque-scroll-list-item-icon"
                              />
                            </div>
                          </div>
                          <div className="trusted-section-marque-scroll-list-item-text">
                            <div>
                              <p>{item.name} </p>
                            </div>
                          </div>
                        </li>
                      ))}
                      {Companys.map((item, index) => (
                        <li
                          key={index + "marquee items"}
                          className="trusted-section-marque-scroll-list-item"
                        >
                          <div>
                            <div>
                              <img
                                src={item.logo}
                                alt={item.name}
                                className="trusted-section-marque-scroll-list-item-icon"
                              />
                            </div>
                          </div>
                          <div className="trusted-section-marque-scroll-list-item-text">
                            <div>
                              <p>{item.name} </p>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </div>
      </IndexComponentTrustedSection>

      <IndexComponentFeatureSection>
        <div>
          <div className="feature-section-header-container">
            <div>
              <HeaderSpan text="AI DRIVEN FEATURE" />

              <div className="feature-section-header-text">
                <h2> From setup to scale, control your AI workforce with ease</h2>{" "}
              </div>
            </div>
            <div>
              <div className=" feature-section-description-text">
                <p>
                  Bugzi AI saves you the hassle of switching back and forth — everything you need is right here
                </p>
              </div>
            </div>
          </div>
          <div className="feature-section-bento-container">
            <div className="feature-section-bento-toprow">
              <div className="feature-section-bento-card-grid-small">
                <div className="feature-section-bento-card">
                  <div className="gradient" />
                  <div className="feature-section-bento-card-container">
                    <div className="feature-section-bento-card-icon-holder">
                      <IndexModelComponent />
                    </div>
                    <div className=" feature-section-bento-card-text-container">
                      <div className="feature-section-bento-card-header-text">
                        <h3>Seamless AI Integrations</h3>
                      </div>
                      <div className="feature-section-bento-card-header-text">
                        <p>
                          Integrate OpenAI, Claude,  Gemini, Meta & more — connect to the right model instantly.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="feature-section-bento-card-grid-big">
                <div className="feature-section-bento-card">
                  <div className="gradient" />
                  <div className="feature-section-bento-card-container">
                    <div className="feature-section-bento-card-icon-holder">
                      <IndexChatComponent />
                    </div>
                    <div className=" feature-section-bento-card-text-container">
                      <div className="feature-section-bento-card-header-text">
                        <h3>AI Utility Hub</h3>
                      </div>
                      <div className="feature-section-bento-card-header-text">
                        <p>
Expand your AI into developer and productivity tools with ease.
 —streamlined and optimized for faster workflows.                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="feature-section-bento-bottomrow">
              <div className="feature-section-bento-card-grid-small">
                <div className="feature-section-bento-card">
                  <div className="gradient" />
                  <div className="feature-section-bento-card-container">
                    <div className="feature-section-bento-card-icon-holder">
                      <IndexPrComponent />
                    </div>
                    <div className=" feature-section-bento-card-text-container">
                      <div className="feature-section-bento-card-header-text">
                        <h3>Multi‑Agent Framework</h3>
                      </div>
                      <div className="feature-section-bento-card-header-text">
                        <p>
                          Run multiple AI agents side‑by‑side—specialized for coding, debugging, writing, browsing, or editing—coordinated seamlessly to keep workflows efficient.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="feature-section-bento-card-grid-big">
                <div className="feature-section-bento-card">
                  <div className="gradient" />
                  <div className="feature-section-bento-card-container">
                    <div className="feature-section-bento-card-icon-holder">
                      <IndexActionComponent />
                    </div>
                    <div className=" feature-section-bento-card-text-container">
                      <div className="feature-section-bento-card-header-text">
                        <h3>Workflow Engine</h3>
                      </div>
                      <div className="feature-section-bento-card-header-text">
                        <p>
                         Configure AI agents to run defined workflows, —delivering consistent and efficient results .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IndexComponentFeatureSection>
      <IndexDemoComponent />
      <IndexFeaturesComponent />
      <IndexIntegrationComponent />
      <IndexReviewsComponent />
      <IndexCtaComponent />
      <IndexFaqComponent />
      <Footer />



    </IndexComponentMainDiv>
  );
};
const Companys = [
  { name: "ChatGPT", logo: GptLogo },
  { name: "Claude", logo: ClaudeLogo },
  { name: "Gemini", logo: GeminiLogo },
  { name: "Meta AI", logo: MetaLogo },
  { name: "Mistral", logo: MistralLogo },
  { name: "DeepSeek", logo: DeepSeekLogo },
  { name: "Grok", logo: GrokLogo },
  { name: "Sonar", logo: SonarLogo },
];

export default IndexComponent;







